import { ReactElement } from 'react';

import {
  Breadcrumb,
  BreadcrumbItem,
  CSS,
  Flex,
  Separator,
  Stack,
  Typography,
} from '@project44/manifest-ds';

export interface Crumb {
  label: string;
  href?: string;
  onClick?: () => void;
  css?: CSS;
}
interface Props {
  breadcrumbs: Crumb[];
  children?: ReactElement;
  css?: CSS;
  hideSeperator?: boolean;
  colorMode?: 'brandBlue' | 'defaultBg';
  breadcrumbsCss?: CSS;
}

export const BreadcrumbsPageHeader = ({
  children,
  breadcrumbs,
  css,
  hideSeperator,
  colorMode = 'brandBlue',
  breadcrumbsCss,
}: Props) => {
  const isDefaultColorMode = colorMode === 'defaultBg';
  const commonStyles: CSS = {
    color: isDefaultColorMode ? '$text-primary' : '$text-contrast',
  };

  const crumbs = [...(breadcrumbs || [])];

  const title = crumbs?.pop();

  const onCrumbClick = (event: MouseEvent, crumb: Crumb) => {
    // prevent a tag default behaviour if onClick handler is provided
    if (crumb.onClick) {
      event.preventDefault();
      crumb.onClick();
    } else if (!crumb.href) {
      // If no href provided - no manipulation with a url should happens
      event.preventDefault();
    }
  };

  return (
    <Flex
      css={{
        backgroundColor: isDefaultColorMode
          ? '$background-primary'
          : '$background-top-nav',
        px: '$x-large',
        py: '$medium',
        ...css,
      }}
      data-testid="breadcrumbs-container"
    >
      <Stack>
        <Breadcrumb css={breadcrumbsCss}>
          {crumbs.map((crumb) => (
            <BreadcrumbItem
              key={crumb.label}
              href={crumb.href || '#'}
              onClick={(event) =>
                onCrumbClick(event as unknown as MouseEvent, crumb)
              }
              css={{ ...commonStyles, ...crumb.css }}
            >
              {crumb.label}
            </BreadcrumbItem>
          ))}
        </Breadcrumb>
        <Typography variant="heading" css={commonStyles}>
          {title?.label}
        </Typography>
      </Stack>
      {children && !hideSeperator && (
        <Separator
          orientation="vertical"
          css={{
            height: 24,
            mx: '$medium',
            backgroundColor: '$text-tertiary',
            alignSelf: 'center',
          }}
        />
      )}
      {children}
    </Flex>
  );
};
